import EngineModule from '../EngineModule';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	allowedCustomers : null,
	id :               'oms-basket',
	insertionPath :    null,
	generateComponentConfiguration : null,
	dependencies :     [],
	async initialize() {
		await app.useBasket();
	}
});
